import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, map } from 'rxjs';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public resources: { prefix: string; suffix: string }[] = [
      {
        prefix: '/assets/i18n/',
        suffix: `.json?cacheBuster=${new Date().getTime()}`
      }
    ]
  ) {}
  /**
   * Gets the translations from the server
   * @param lang
   * @returns {any}
   */
  public getTranslation(lang: string): any {
    return forkJoin(this.resources.map((config) => this.http.get(`${config.prefix}${lang}${config.suffix}`))).pipe(
      map((response) =>
        response.reduce((a: any, b: any) => {
          const obj: any = Object.assign(a, b);
          return obj;
        })
      )
    );
  }
}
